import { TextRef } from '../../types/typing.ts';
import { gsap } from 'gsap';

class TextControl {
  cacheMap: Record<string, TextRef> = {};

  enter(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    textRef: any;
  }) {
    const { id, textRef } = data;
    let item: TextRef;

    if (this.cacheMap[id]) {
      item = this.cacheMap[id];
      item.textContainer.visible = true;
    } else {
      textRef.current.forEach((ref: TextRef) => {
        console.log('ref.id = ', ref.id, ' id = ', id);
        if (ref.id === id) {
          ref.textContainer.visible = true;
          this.cacheMap[id] = ref;
        }
      });
    }
  }

  update(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    textRef: any;
  }) {
    const { id, startTime, endTime, time, textRef } = data;
    const item = this.cacheMap[id];

    if (!item || !item.textContainer || !textRef.current.get(id)) return;
    if (item.pathPoints.length > 0) {
      // Calculate progress ratio based on current time
      const duration = endTime - startTime;
      const currentTime = time - startTime;
      const progress = Math.max(0, Math.min(1, currentTime / duration));

      // Clear any existing GSAP animations for this sprite
      gsap.killTweensOf(item.textContainer);

      // Create a timeline for smooth animation
      //const timeline = gsap.timeline();

      // Calculate total path length for even distribution
      const totalPoints = item.pathPoints.length;
      //const segmentDuration = duration / (totalPoints - 1);

      // Calculate which segment we should be on
      const currentSegmentIndex = Math.floor(progress * (totalPoints - 1));
      const nextSegmentIndex = Math.min(
        currentSegmentIndex + 1,
        totalPoints - 1
      );

      // Calculate sub-progress within current segment
      const segmentProgress = (progress * (totalPoints - 1)) % 1;

      // Get current and next points
      const currentPoint = item.pathPoints[currentSegmentIndex];
      const nextPoint = item.pathPoints[nextSegmentIndex];

      // Interpolate position
      const currentX =
        currentPoint.x + (nextPoint.x - currentPoint.x) * segmentProgress;
      const currentY =
        currentPoint.y + (nextPoint.y - currentPoint.y) * segmentProgress;

      // Update sprite position immediately
      gsap.set(item.textContainer, {
        x: currentX,
        y: currentY,
        onUpdate: () => {
          item.textContainer.position.x = currentX;
          item.textContainer.position.y = currentY;
        },
      });
    }
  }

  leave(data: {
    id: string;
    startTime: number;
    endTime: number;
    time: number;
    textRef: any;
  }) {
    const { id, startTime, endTime, time, textRef } = data;
    if (!this.cacheMap[id]) {
      textRef.current.forEach((ref: TextRef) => {
        console.log('ref.id = ', ref.id, ' id = ', id);
        if (ref.id === id) {
          ref.textContainer.visible = true;
          this.cacheMap[id] = ref;
        }
      });
    }
    const item = this.cacheMap[id];
    if (!item) return;
    if (time > endTime || time < startTime) {
      console.log('item: ', item);
      item.textContainer.visible = false;
    } else {
      item.textContainer.visible = true;
    }
  }

  destroy() {
    this.cacheMap = {};
  }
}

export default new TextControl();
